// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"8ddf212c","109":"674e7193","474":"3458f309","641":"7080ae0e","833":"37b02856"}[chunkId] + ".css";
};